// @ts-nocheck
// Auto-migrated from js/mockData.js
// ============================================================
// EasyShare 运营管理系统 · Mock 数据
// 与 PRD / IA / 渠道字段三份文档对齐
// ============================================================

import { ROLES, PERMISSIONS, SESSION } from "./session";
import { GAMES } from "./games";
import { PACKAGES } from "./packages";
import { CHANNELS, USERS, AUDIT_LOGS } from "./admin";
import {
  FUNNEL_LEVELS,
  FUNNEL_DATA,
  CHANNEL_COMPARE,
  TREND_DATA,
  USER_PATH_EXAMPLE,
  SHARE_RECORDS,
  GLOBAL_STATS,
  NOTIFICATIONS,
} from "./analytics";
import { SDK_VERSIONS, SDK_MONITOR } from "./sdk";
import { TEMPLATES, LANDING_PAGES } from "./content";
import { SHARE_CONFIGS, SHARE_SCENARIOS } from "./share-configs";

export { SHARE_SCENARIOS };

export const seedMock = {
  ROLES,
  PERMISSIONS,
  GAMES,
  PACKAGES,
  CHANNELS,
  FUNNEL_LEVELS,
  FUNNEL_DATA,
  CHANNEL_COMPARE,
  SDK_VERSIONS,
  USERS,
  AUDIT_LOGS,
  NOTIFICATIONS,
  USER_PATH_EXAMPLE,
  TREND_DATA,
  SESSION,
  TEMPLATES,
  LANDING_PAGES,
  SHARE_CONFIGS,
  SHARE_RECORDS,
  SDK_MONITOR,
  GLOBAL_STATS,
};

// 补全 GLOBAL_STATS 派生数据
seedMock.GLOBAL_STATS.top_games = seedMock.GAMES.filter((g) => g.status === "active");
seedMock.GLOBAL_STATS.channel_summary = seedMock.CHANNEL_COMPARE;

seedMock.SHARE_SCENARIOS = SHARE_SCENARIOS;
